/**
 * 应用模块统一注册入口
 * 集中管理所有功能模块的注册和初始化
 */

import { moduleManager } from './ModuleManager';
import { DisableConsoleModule } from './DisableConsoleModule';
import { SystemSoundModule } from './SystemSoundModule';
import { AutoRefreshModule } from './AutoRefreshModule';

/**
 * 注册所有应用模块
 * 这个函数应该在应用启动时尽早调用
 */
export function registerAppModules(): void {
  // 注册所有功能模块
  moduleManager.registerMultiple([
    new DisableConsoleModule(),    // Priority 1 - 控制台禁用
    new AutoRefreshModule(),        // Priority 4 - 自动刷新
    new SystemSoundModule(),        // Priority 5 - 系统音效
  ]);
}

/**
 * 初始化所有已注册的模块
 */
export async function initializeAppModules(): Promise<void> {
  await moduleManager.initializeAll();
}

/**
 * 清理所有模块 (用于应用卸载时)
 */
export function destroyAppModules(): void {
  moduleManager.destroyAll();
}

// 导出模块管理器供高级用途使用
export { moduleManager } from './ModuleManager';
export type { AppModule } from './ModuleManager';
